<template>
    <v-container>
        <v-row>
            <v-col cols="12">
                <h2 class="mb-5 primary--text">Configuração do vínculo hierárquico do assistente</h2>
            </v-col>
        </v-row>

        <v-form ref="form" @submit.prevent="saveAssistant">
            <v-row>
                <v-col cols="12" md="6">
                    <v-text-field v-model="assistantCode" label="Código do usuário assistente:" class="required"
                                  outlined maxlength="10" placeholder="Informe o código do usuário assistente"
                                  v-input-filter="[$filters.numeric]" :rules="[$rules.required]" />
                </v-col>
                <v-col cols="12" md="6">
                    <v-text-field v-model="assistantName" label="Nome do assistente:" class="required" outlined
                                  placeholder="Informe o nome do assistente" maxlength="200"
                                  v-input-filter="[$filters.textnumeric]" :rules="[$rules.required]" />
                </v-col>
                <v-col cols="12" md="6">
                    <v-text-field ref="gnOrRcField" v-model="gnOrRcCode" label="Código do usuário GN ou RC:"
                                  hint="Iremos buscar o GN/RC após a digitação do mesmo" class="required" outlined
                                  placeholder="Informe o código do usuário GN ou RC" maxlength="10"
                                  v-input-filter="[$filters.numeric]" :rules="[$rules.required]" @keydown="debouncedQuery" />
                </v-col>
                <v-col cols="8" sm="10" md="4">
                    <v-select v-model="idTipo" :items="tipoAssistentes" item-text="tipo_assistente" item-value="id_tipo"
                              label="Tipo de Assistente" outlined :rules="[$rules.required]" placeholder="Insira o tipo do assistente" />
                </v-col>
                <v-col cols="4" sm="2" md="2" class="mt-7">
                    <v-btn class="transition" color="primary" type="submit" :disabled="searchGnOrRc">Salvar</v-btn>
                </v-col>
            </v-row>
        </v-form>
        <v-row>
            <v-col cols="12" md="6">
                <label class="ml-1" style="color: var(--darkgray); display: block;">
                    Faça o upload de um arquivo em formato .csv para importar vínculos hierárquicos nestes cadastros:
                </label>
            </v-col>
        </v-row>
        <v-row class="d-flex align-center mb-5">
            <v-col class="col-12 col-sm-9 col-md-4">
                <v-file-input
                        class="mt-3"
                        accept=".csv"
                        dense
                        outlined
                        placeholder="Insira um arquivo CSV"
                        v-model="csvUsuarios"
                ></v-file-input>
            </v-col>
            <v-col cols="12" sm="3" md="3" class="mt-n3">
                <v-btn @click="importarAssistentes" v-if="csvUsuarios" color="secondary">
                    <v-icon small style="margin-right: 8px"> cloud_download </v-icon>
                    Importar
                </v-btn>
                <v-btn @click="downloadImportAssistantModel" v-else color="primary">
                    <v-icon small style="margin-right: 8px"> cloud_download </v-icon>
                    Modelo
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <h2 class="mb-5 primary--text">Listagem de assistentes cadastrados</h2>
            </v-col>
        </v-row>

        <v-layout class="d-flex justify-space-between flex-wrap">
            <v-btn class="transition" color="primary" rounded @click="toggleFiltro">
                <v-icon small style="margin-right: 10px;">rod-filter</v-icon>
                Filtrar por:
                <v-icon :class="{ 'rotate90': filter_open }" small>chevron_right</v-icon>
            </v-btn>
            <v-btn class="transition" color="primary" rounded @click="exportarExcel">
                <v-icon left size="18">
                    mdi-file-chart
                </v-icon>
                Salvar Relatório
            </v-btn>
        </v-layout>
        <collapse-transition>
            <m-form ref="filter" v-if="filter_open" class="mt-4 ml-2">
                <v-row>
                    <v-col cols="6">
                        <m-text-field outlined label="Cód. Usuário assistente:" placeholder="Insira o código do usuário assistente" v-model="filters.codigo_assistente"
                        />
                    </v-col>
                    <v-col cols="6">
                        <m-text-field outlined label="Nome assistente:" placeholder="Insira o nome assistente" v-model="filters.nome_assistente" />
                    </v-col>
                    <v-col cols="6">
                        <m-text-field outlined label="Vínculo comercial:" placeholder="Insira o vínculo comercial" v-model="filters.link_comercial"
                        />
                    </v-col>
                    <v-col cols="6">
                        <v-select label="Tipo do usuário vinculado:" placeholder="Selecione o tipo do usuário" outlined
                                  menu-props="offsetY" hide-details v-model="filters.link_usuario" :items="type_users"
                                  item-text="label" item-value="value" />
                    </v-col>
                    <v-col cols="6" class="mb-4">
                        <v-select label="Tipo de Assistente:" placeholder="Selecione o tipo do assistente" outlined
                                  menu-props="offsetY" hide-details v-model="filters.id_tipo" :items="tipoAssistentes"
                                  item-text="tipo_assistente" item-value="id_tipo" />
                    </v-col>
                </v-row>

                <v-row class="justify-space-between mt-4">
                    <v-col cols="6" md="3">
                        <v-btn color="secondary" block @click="limpar">
                            Limpar
                        </v-btn>
                    </v-col>
                    <v-col cols="6" md="3">
                        <v-btn color="primary" block @click="filtrar">
                            Filtrar
                        </v-btn>
                    </v-col>
                </v-row>
            </m-form>
        </collapse-transition>

        <v-row>
            <v-col cols="12">
                <DataTable ref="datatable" url="/painel/assistants" class="pt-2" :headers="headers"
                           :calculate-widths="true" :filter="filterTable">
                    <template v-slot:header="header">
                        <th v-for="(header, i) in headers" :key="i" class="pr-2" style="height: 5px">
                            <div v-if="header.tooltip" class="tooltip-icon position-relative"
                                 style="width: 18px; height: 18px; position: relative;display:block; margin-top: -35px; margin-left: calc(100% - 18px)">
                                <v-tooltip bottom color="#222">
                                    <template v-slot:activator="{ on, attrs }">
                                        <span v-bind="attrs" v-on="on">
                                            <div class="d-flex" style="right:5">
                                                <v-icon size="18" color="primary">{{ header.tooltip.icon }}</v-icon>
                                            </div>
                                        </span>
                                    </template>
                                    <p class="mb-0" style="color:whitesmoke;max-width: 250px;">
                                        {{ header.tooltip.text }}
                                    </p>
                                </v-tooltip>
                            </div>
                        </th>
                    </template>
                    <template v-slot:items="{item}">
                        <td>{{ item.codigo_assistente }}</td>
                        <td>{{ item.nome_assistente }}</td>
                        <td>{{ item.link_comercial }}</td>
                        <td>{{ item.link_usuario }}</td>
                        <td>{{ item.tipo_assistente && item.tipo_assistente.tipo_assistente || 'N/A' }}</td>
                        <td>
                            <v-col xs12>
                                <v-btn icon>
                                    <v-icon small @click="deleteAssistant(item)">mdi-delete</v-icon>
                                </v-btn>
                            </v-col>
                        </td>
                    </template>
                </DataTable>
            </v-col>
        </v-row>
        <dialog-exibir-erros-importacao :errors="logImportacao" v-model="dialogResultadoImportacao" />
    </v-container>
</template>

<script>
  import { alert, sleep, notification } from '@/plugins/helpers'
  import { CommercialHierarchyTypes } from '@/plugins/constants'
  import { AlertTypes } from '../../plugins/alerts_types'
  import DialogExibirErrosImportacao from '../../dialogs/DialogExibirErrosImportacao.vue'
  import * as Qs from 'qs'

  export default {
    name: 'Assistant',
    components: { DialogExibirErrosImportacao },
    data () {
      return {
        pagination: {
          sortBy: [], descending: []
        },
        assistantCode: '',
        gnOrRcCode: '',
        assistantName: '',
        idTipo: '',
        logImportacao: [],
        dialogResultadoImportacao: false,
        errorList: [],
        assistantModelUrl: '',
        assistants: [],
        csvUsuarios: null,
        filters: {
          codigo_assistente: null,
          link_comercial: null,
          link_usuario: null,
          nome_assistente: null,
          id_tipo: null
        },
        tipoAssistentes: [],
        type_users: [
          { label: CommercialHierarchyTypes.Todos.text, value: '' },
          { label: CommercialHierarchyTypes.RC.text, value: CommercialHierarchyTypes.RC.text },
          { label: CommercialHierarchyTypes.GN.text, value: CommercialHierarchyTypes.GN.text }
        ],
        filterTable: {},
        filter_open: false,
        headers: [
          { text: 'Cód. Usuário Assistente', value: 'assistantCode' },
          { text: 'Nome assistente', value: 'assistantName' },
          { text: 'Vinculo comercial hierárquico', width: '240px', value: 'link_comercial', tooltip: { text: 'O sistema irá autenticar o assistente contendo a mesma hierarquia do GN ou RC vinculado aqui.', icon: 'mdi-help-box' } },
          { text: 'Tipo do usuário vinculado', value: 'gnOrRcCode' },
          { text: 'Tipo do Assistente', value: 'tipo_assistente.tipo_assistente' },
          { text: '', value: 'action', sortable: false }
        ],
        timeout: null,
        gnRcVerify: null
      }
    },
    computed: {
      searchGnOrRc () {
        return this.gnRcVerify == null
      },
      params () {
        return { pagination: this.pagination }
      }
    },
    mounted () {
      Promise.all([this.buscaTiposAssistentes(), this.getDownloadLink()])
    },
    methods: {
      buscaTiposAssistentes () {
        this.$http.get('/painel/assistant/types').then(response => {
          this.tipoAssistentes = response.data.tiposAssistentes
        })
          .catch(error => {
            notification(AlertTypes.ERROR, error, 'Erro ao buscar os tipos de assistentes')
          })
      },
      toggleFiltro () {
        this.filter_open = !this.filter_open
      },
      debouncedQuery () {
        this.gnRcVerify = null
        if (this.timeout) {
          clearTimeout(this.timeout)
        }

        this.timeout = setTimeout(this.verifyGnOrRc, 1000)
      },
      async verifyGnOrRc () {
        if (this.gnOrRcCode && this.gnOrRcCode.length >= 5) {
          const result = await this.$http.get(`/painel/getGnOrRc/${this.gnOrRcCode}`).then(response => response.data)

          if (result && result.nome) {
            this.gnOrRcCode = `${this.gnOrRcCode} - ${result.nomePessoa}`
            this.gnRcVerify = result
          } else {
            notification(AlertTypes.WARN, 'Usuário não identificado como GN ou RC. Verifique e tente novamente.')
          }
        }
      },
      saveAssistant () {
        const form = this.$refs.form
        if (!form.validate()) {
          form.resetValidation()
          sleep(100).then(() => form.validate())
          return
        }

        if (!this.gnRcVerify) {
          notification(AlertTypes.WARN, 'Código do usuário RC ou GN não identificado. Verifique e tente novamente')
          return
        }

        const params = {
          'codigo_assistente': this.assistantCode,
          'codigo_gn_ou_rc': this.gnRcVerify.login,
          'link_comercial': `${this.gnOrRcCode} - ${this.gnRcVerify.nomePessoa}`,
          'link_usuario': this.gnRcVerify.nome,
          'nome_assistente': this.assistantName,
          'id_tipo': this.idTipo
        }

        try {
          alert({
            text: `Tem certeza que adicionar esse assistente?`,
            buttons: {
              'Cancelar': () => true,
              'Confirmar': async () => {
                await this.$http.post(`/painel/assistant`, params)
                notification(AlertTypes.SUCCESS, 'Cadastro de usuário assistente realizado com sucesso!')
                this.resetData()
              }
            }
          })
        } catch (e) {
          notification(AlertTypes.ERROR, e, 'Não foi possível adicionar o assistente.')
        }
      },
      resetData () {
        this.gnRcVerify = null
        this.$refs.form.reset()
        this.$refs.datatable.reload()
      },
      deleteAssistant (assistant) {
        try {
          alert({
            text: `Deseja excluir o cadastro do usuário assistente ${assistant.codigo_assistente}?`,
            buttons: {
              'Cancelar': () => true,
              'Confirmar': async () => {
                await this.$http.delete(`/painel/assistant/${assistant.id}`)
                this.$refs.datatable.reload()
                notification(AlertTypes.SUCCESS, 'Cód. Usuário Assistente excluído com sucesso.')
              }
            }
          })
        } catch (e) {
          notification(AlertTypes.ERROR, e, 'Não foi possível deletar o assistente')
        }
      },
      exportarExcel () {
        const filtros = { ...this.filters }
        const encoded_params = Qs.stringify({
          filter: filtros,
          pagination: { sortBy: this.params.pagination.sortBy, descending: this.params.pagination.descending },
          headers: this.headers.map(header => header.value),
          headers_formatado: this.headers.map(header => header.text)
        }, {
          arrayFormat: 'brackets',
          encode: true
        })
        try {
          window.open(`${this.ws}/vinculo_hierarquico_assistente/exportar?${encoded_params}`)
        } catch (error) {
          notification(AlertTypes.ERROR, `${error.response?.data?.error || error.message}`)
        }
      },
      filtrar () {
        this.filterTable = { ...this.filters }
      },
      limpar () {
        this.filters = {
          codigo_assistente: null,
          link_comercial: null,
          link_usuario: null,
          nome_assistente: null,
          id_tipo: null
        }
        this.filtrar()
      },
      downloadImportAssistantModel () {
        window.open(`${this.assistantModelUrl}exemploassistente`, '_blank')
      },
      getDownloadLink () {
        this.$http.get('/link').then(res => {
          if (res.data) {
            this.assistantModelUrl = res.data
          }
        })
      },
      importarAssistentes () {
        if (this.csvUsuarios) {
          let formData = new FormData()
          formData.append('file', this.csvUsuarios)

          this.$http.post('/painel/assistant/importar', formData)
            .then((res) => {
              if (res.data) {
                if (!res.data.ok) {
                  notification(AlertTypes.ERROR, res.data.msg_Erro, 'Erro ao inserir os assistentes via CSV!')
                } else {
                  this.resetData()
                  this.logImportacao = res.data.saida
                  this.dialogResultadoImportacao = true
                }
              }
            })
            .catch(e => {
              notification(AlertTypes.ERROR, 'Não foi possível importar os assistentes, Erro: '.e)
            }).finally(() => {
              this.csvUsuarios = null
            })
        }
      }
    }
  }
</script>
